<template>
  <!-- Recupero della password: la stessa scena dell'accesso (_auth.scss),
       pannello di marca e foglio con il modulo. Tre vie: email, codice
       fiscale (SMS), numero di riserva. -->
  <div class="auth">
    <aside class="auth__brand">
      <b-img
        class="auth__logo"
        :src="require(`@/assets/${$root.scope}/logo_area_pubblica_reg.png`)"
        :alt="$t('PasswordRecovery.logo_alt')"
      ></b-img>
    </aside>

    <main class="auth__panel">
      <div class="auth__card">
        <router-link class="back-link" :to="{ name: 'LoginPage' }">
          <b-icon icon="arrow-left" aria-hidden="true"></b-icon>
          {{ $t('torna_login') }}
        </router-link>
        <h1 class="auth__title">{{ $t('recupera_password') }}</h1>

        <template v-if="passwordRecoveryType === 1">
          <template v-if="status.recoverSent === true">
            <p class="auth__lead">{{ $t('mail_inviata') }}</p>
            <div class="auth__actions">
              <b-button
                type="button"
                variant="outline-secondary"
                block
                @click="passwordRecoveryType = 2"
              >
                {{ $t('non_ho_ricevuto_email') }}
              </b-button>
            </div>
          </template>
          <template v-else>
            <p class="auth__lead">{{ $t('inserisci_email_registrazione') }}</p>
            <b-form @submit.prevent="OnEmailSubmit">
              <b-form-group :label="$t('email')" label-for="recupero-email">
                <b-form-input
                  id="recupero-email"
                  name="email"
                  type="email"
                  v-model="recoverEmail"
                  placeholder="email@ ..."
                  autocomplete="email"
                  :state="recoverEmail == null ? null : validEmail"
                  required
                ></b-form-input>
              </b-form-group>
              <div class="auth__actions">
                <b-button
                  :disabled="recoverEmail == null ? false : !validEmail"
                  type="submit"
                  variant="secondary"
                  block
                  >{{ $t('invia') }}</b-button
                >
                <b-button
                  @click="$router.go(-1)"
                  type="button"
                  variant="outline-secondary"
                  block
                  >{{ $t('annulla') }}</b-button
                >
              </div>
              <div class="auth__divider"><span>{{ $t('oppure') }}</span></div>
              <b-button
                type="button"
                variant="popup-button"
                block
                @click="passwordRecoveryType = 2"
              >
                {{ $t('non_ricordo_email') }}
              </b-button>
            </b-form>
          </template>
        </template>

        <template v-else-if="passwordRecoveryType === 2">
          <template v-if="status.recoverSent === true">
            <p class="auth__lead">{{ $t('sms_inviato_cf') }}</p>
            <div class="auth__actions">
              <b-button
                type="button"
                variant="outline-secondary"
                block
                @click="passwordRecoveryType = 3"
              >
                {{ $t('non_ho_ricevuto_sms') }}
              </b-button>
            </div>
          </template>
          <template v-else>
            <p class="auth__lead">{{ $t('inserisci_codice_fiscale') }}</p>
            <b-form @submit.prevent="OnCFSubmit">
              <b-form-group :label="$t('codice_fiscale')" label-for="recupero-cf">
                <b-form-input
                  id="recupero-cf"
                  class="text-uppercase"
                  name="cf"
                  type="text"
                  v-model="recoverCF"
                  :placeholder="$t('placeholder_cf')"
                  maxlength="16"
                  minlength="16"
                  :state="recoverCF == null ? null : validCf"
                  required
                ></b-form-input>
              </b-form-group>
              <div class="auth__actions">
                <b-button
                  :disabled="recoverCF == null ? false : !validCf"
                  type="submit"
                  variant="secondary"
                  block
                  >{{ $t('invia') }}</b-button
                >
                <b-button
                  @click="passwordRecoveryType = 1"
                  type="button"
                  variant="outline-secondary"
                  block
                  >{{ $t('annulla') }}</b-button
                >
              </div>
            </b-form>
          </template>
        </template>

        <template v-else>
          <template v-if="status.recoverSent === true">
            <p class="auth__lead">{{ $t('sms_inviato_telefono_riserva') }}</p>
            <p class="auth__lead">
              {{ $t('nessun_link_contatta_assistenza') }}
              <a class="auth__forgot mb-0" href="mailto:assistenza@concura.it">
                {{ $t('invia_richiesta_supporto') }}</a
              >.
            </p>
            <div class="auth__actions">
              <b-button
                @click="$router.push({ name: 'LoginPage' })"
                variant="secondary"
                block
                >{{ $t('torna_login') }}</b-button
              >
            </div>
          </template>
          <template v-else>
            <p class="auth__lead">{{ $t('inserisci_codice_fiscale') }}</p>
            <b-form @submit.prevent="OnCFSubmit">
              <b-form-group :label="$t('codice_fiscale')" label-for="recupero-cf-riserva">
                <b-form-input
                  id="recupero-cf-riserva"
                  class="text-uppercase"
                  name="cf"
                  type="text"
                  v-model="recoverCF"
                  :placeholder="$t('placeholder_cf')"
                  maxlength="16"
                  minlength="16"
                  :state="recoverCF == null ? null : validCf"
                  required
                ></b-form-input>
              </b-form-group>
              <div class="auth__actions">
                <b-button
                  :disabled="recoverCF == null ? false : !validCf"
                  type="submit"
                  variant="secondary"
                  block
                  >{{ $t('invia_numero_riserva') }}</b-button
                >
                <b-button
                  @click="$router.go(-1)"
                  type="button"
                  variant="outline-secondary"
                  block
                  >{{ $t('annulla') }}</b-button
                >
              </div>
            </b-form>
          </template>
        </template>
      </div>
    </main>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "PasswordRecovery",
  data() {
    return {
      form: {
        email: this.$route.query.email,
        password: null,
        password_confirmation: null,
        token: this.$route.query.token,
      },
      has_minimum_lenth: true,
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      has_special: false,
      recoveryTypes: {
        1: "mail",
        2: "firstPhone",
        3: "secondPhone",
      },
      passwordRecoveryType: 1,
      recoverCF: null,
      recoverEmail: null,
      showSecondNumberOption: false,
    };
  },
  computed: {
    validatePassword() {
      if (this.form.password) {
        this.has_minimum_lenth = this.form.password.length >= 8;
        this.has_number = /\d/.test(this.form.password);
        this.has_lowercase = /[a-z]/.test(this.form.password);
        this.has_uppercase = /[A-Z]/.test(this.form.password);
        this.has_special = /[^\p{L}\p{N}\s]/u.test(this.form.password);
        return (
          this.has_minimum_lenth &&
          this.has_number &&
          this.has_lowercase &&
          this.has_uppercase &&
          this.has_special
        );
      }
      return false;
    },
    validateConfirm() {
      if (this.form.password) {
        return this.form.password_confirmation === this.form.password;
      }
      return false;
    },
    validEmail() {
      const validRegex =
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      return this.recoverEmail.match(validRegex) ? true : false;
    },
    validCf() {
      const validRegex =
        /^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/;
      if (this.recoverCF === 16) {
        return this.recoverCF.match(validRegex) ? true : false;
      }
      return this.recoverCF.match(validRegex) ? true : false;
    },
    ...mapState("utente", ["status", "user"]),
  },
  watch: {
    passwordRecoveryType: function (val) {
      this.resetRecoverAction();
    },
  },
  methods: {
    ...mapActions("utente", [
      "resetPassword",
      "recoverPassword",
      "recoverPasswordViaCf",
      "resetRecoverAction",
    ]),
    OnEmailSubmit() {
      const self = this;
      this.recoverPassword({ email: this.recoverEmail })
        .then((res) => {
          self.recoverEmail = null;
        })
        .catch((error) => {});
    },
    OnCFSubmit() {
      const self = this;
      var form = { cf: this.recoverCF };
      if (this.passwordRecoveryType > 2) {
        form = { cf: this.recoverCF, second: true };
      }
      this.recoverPasswordViaCf(form)
        .then((res) => {
          // self.recoverCF = null;
          self.showSecondNumberOption = true;
        })
        .catch((error) => {});
    },
  },
};
</script>
